import styles from './productdetails.module.css'
import { Loader,SubHeadingTitle } from "../../../components/shared/index";
import {ImageGallery} from '../../../components/index'
import {useGetWishLists } from '../../../queries/useWishListQuery';

const ProductImage = ({
  productId,
  productName,
  images,
  isPending,
  isError,
  error
}) => {
const { data: wishItems = [] } = useGetWishLists();
console.log(images,"imges");   
  return (
      <div className={styles.leftSection}>
    {isPending ? (
      <div className={styles.productInfoLoader}>
        <Loader title="Loading product image..." />
      </div>
    ) : isError ? (
      <div className={styles.productInfoError}>
        <SubHeadingTitle
         subTitle={error?.message || "Failed to load product details"}
         style={styles.errorMessage}
        />
      </div>
    ) : (
      // <ImageGallery     productId={productId} wishItems={wishItems} images={images || []} />
      <div className={`${styles.leftSection} ${styles.prodimge}`}>
 <ImageGallery
  productId={productId}
  productName={productName}
  wishItems={wishItems}
  images={images || []}
/>
</div>
    )}
  </div>
  )
}
export default ProductImage